<template>
  <RmField :field="lotId">
    <div
      class="md:bg-white md:shadow-2xl flex flex-wrap justify-between gap-2 p-4 bg-gray-200 border border-gray-200 rounded-[12px]"
    >
      <div class="mx-auto flex justify-center items-center">
        <div class="text-2xl font-extrabold text-green-500">
          {{ elkaPrice.toLocaleString($i18n.locale) }}&nbsp;₽
        </div>
      </div>
    </div>
  </RmField>
</template>

<script>
import RmField from '~/components/shared/rm_field.vue';
import { useLot } from '~/composables/useLot';
export default {
  components: {
    RmField,
  },
  props: {
    lotId: {
      type: [String, Number],
      required: true,
    },
  },
  setup (props) {
    const { lot } = useLot(props.lotId)
    const config = useRuntimeConfig()

    const elkaPrice = computed(() => {
      const lotId = Number(props.lotId)
      return config.public.elkaPrices?.[lotId] || config.public.elkaPrices?.[45933]
    })

    return {
      config,
      elkaPrice,
      renterServiceFee: computed(() => lot.value.priceDetails?.renterServiceFee || 0),
      rentalDays: useOrder().rentalDays,
    }
  },
}
</script>
